// sekcja "Nasze wartości" z 4 ikonami i podpisami
// @ts-nocheck

import React from 'react';
import classnames from 'classnames';
import { HtmlBlock } from 'components/containers/HtmlBlock';

import styles from 'theme/pages/Home/components/OurValues/OurValues.module.scss';

export const OurValues = () => {
  return (
    <div
      className={classnames(
        styles.componentWrapper,
        'StylePath-Pages-Home-components-OurValues'
      )}>
      <HtmlBlock
        sectionId="HOMEPAGE_VALUES"
        articleId="HOMEPAGE_VALUES_SECTION"
        hasSeoTitle
      />
    </div>
  );
};

export default OurValues;

